import { Popover } from "antd-mobile"
import styled from "styled-components"

export const MealTypePopover = styled(Popover.Menu)`
  --arrow-size: 0px;

  .adm-popover-inner {
    border: 1px solid
      var(--Schemes-Outline-Outline-Variant, rgba(0, 38, 58, 0.14));
    box-shadow: 0 12px 16px -4px rgba(16, 24, 40, 0.08),
      0 4px 6px -2px rgba(16, 24, 40, 0.03);
  }

  .adm-popover-menu-list-inner {
    padding: 4px 0px;
  }

  .adm-popover-menu-item {
    padding-left: 0px;
    width: 220px;

    &:first-child {
      .adm-popover-menu-item-text {
        border-top: none;
      }
    }

    .adm-popover-menu-item-text {
      padding: 8px 12px;
      line-height: 160%;
      font-weight: 400px;
      font-size: 16px;
    }
  }
`

export const MealTypeValueBox = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;

  border-radius: 99px;
  background: ${(props) => (props.$isActive ? "rgba(0, 0, 0, 0.05)" : "#fff")};
  cursor: pointer;
  padding: var(--spacing_xxs, 4px) var(--spacing_m, 12px)
    var(--spacing_xxs, 4px) var(--spacing_l, 16px);
`

export const MealTypeValue = styled.p<{ $hasValue: boolean }>`
  font-size: 16px;
  font-weight: 600;
  line-height: 160%;
  color: ${(props) =>
    props.$hasValue
      ? "var(--Schemes-Surface-On-surface-On-Surface, #1C1F21)"
      : "var(--Schemes-System-color-Scrim, rgba(5, 5, 5, 0.36))"};
`
